import { render, staticRenderFns } from "./GoBackButton.vue?vue&type=template&id=2d68817a&scoped=true"
import script from "./GoBackButton.vue?vue&type=script&lang=js"
export * from "./GoBackButton.vue?vue&type=script&lang=js"
import style0 from "./GoBackButton.vue?vue&type=style&index=0&id=2d68817a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68817a",
  null
  
)

export default component.exports